import React from 'react';

import {Button, Typography} from '@mui/material';
import {Modal as ModalComponent} from 'presentation/components/Modal';
import {translations} from 'presentation/translations-new';

type ModalProps = {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const {title, subtitle, sectionOne, sectionTwo} =
	translations['pt-br'].privateFlow.refund.receiptRegistrationPage.fiscalDocument.modal;

const {understood} = translations['pt-br'].commons;

export const Modal = ({open, setOpen}: ModalProps) => (
	<ModalComponent.Root open={open} onClose={() => setOpen(false)}>
		<ModalComponent.Header title={title} onClose={() => setOpen(false)} />
		<ModalComponent.Content
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 2,
			}}>
			<Typography fontWeight={700}>{subtitle}</Typography>
			<Typography>
				<b>{sectionOne.title}</b> {sectionOne.text}
			</Typography>
			<Typography>
				<b>{sectionTwo.title}</b> {sectionTwo.text}
			</Typography>
		</ModalComponent.Content>

		<ModalComponent.Footer>
			<Button fullWidth variant="contained" onClick={() => setOpen(false)}>
				{understood}
			</Button>
		</ModalComponent.Footer>
	</ModalComponent.Root>
);
